import { startLoading, stopLoading } from 'app/modules/cms/service/store/cms-dispatchs';
import { SET_SHOW_ELIGIBILITY_MODAL } from 'app/modules/step-engine/service/store/step-engine-actions';
import {
  setStepEngineSubscription,
  setStepEngineSubscriber
} from 'app/modules/step-engine/service/store/step-engine-dispatchs';
import axios from 'axios';
import {
  INVALID_SN_CANCEL_BTN_PRISMIC_ATTRIBUTE,
  INVALID_SN_MSG_PRISMIC_ATTRIBUTE,
  REQUIRED_TOKEN_CANCEL_BTN_PRISMIC_ATTRIBUTE,
  REQUIRED_TOKEN_MSG_PRISMIC_ATTRIBUTE
} from '../constants/constants';

export const ACTION_TYPES = {
  INIT: 'kubrickManagement/INIT',
  SET_SUBSCRIPTION: 'kubrickManagement/SET_SUBSCRIPTION',
  GET_SUBSCRIPTION_FROM_SESSION: 'kubrickManagement/GET_SUBSCRIPTION_FROM_SESSION',
  SET_SUBSCRIBER: 'kubrickManagement/SET_SUBSCRIBER',
  LOGOUT: 'kubrickManagement/LOGOUT',
  SET_SIDEBARE_URLS: 'kubrickManagement/SET_SIDEBARE_URLS',
  SET_MODAL_MSG: 'kubrickManagement/SET_MODAL_MSG',
  SET_MODAL_CANCEL_BTN: 'kubrickManagement/SET_MODAL_CANCEL_BTN',
  ADDITIONAL_CHECK_SSO: 'kubrickManagement/ADDITIONAL_CHECK_SSO'
};

const initialState = {
  isAuthenticated: false,
  subscriber: null,
  subscription: null,
  logoutDetails: null,
  sideBarUrls: null,
  modalMsg: null,
  modalCancelBtn: null,
  additionalDataSsoIsChecked: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.SET_SUBSCRIPTION:
      return {
        ...state,
        isAuthenticated: true,
        subscription: action.payload,
        subscriber: action.payload.subscriber,
      };
    case ACTION_TYPES.GET_SUBSCRIPTION_FROM_SESSION:
      return {
        ...state,
        isAuthenticated: true,
        subscription: action.payload,
        subscriber: action.payload.subscriber,
      };
    case ACTION_TYPES.SET_SUBSCRIBER:
      return {
        ...state,
        isAuthenticated: true,
        subscription: { ...state.subscription, subscriber: action.payload },
        subscriber: action.payload
      };
    case ACTION_TYPES.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        logoutDetails: action.payload,
      };
    case ACTION_TYPES.SET_MODAL_MSG:
      return {
        ...state,
        modalMsg: action.payload,
      };
    case ACTION_TYPES.SET_MODAL_CANCEL_BTN:
      return {
        ...state,
        modalCancelBtn: action.payload,
      };
    case ACTION_TYPES.SET_SIDEBARE_URLS: {
      return {
        ...state,
        sideBarUrls: action.payload,
      }
    }
    case ACTION_TYPES.ADDITIONAL_CHECK_SSO: {
      return {
        ...state,
        additionalDataSsoIsChecked: action.payload,
      }
    }
    case ACTION_TYPES.INIT:
      return initialState;
    default:
      return state;
  }
};

// Actions
export const setSubscription = (data?: any) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_SUBSCRIPTION,
    payload: {
      ...data,
      insuredGoods: data?.insuredGoods.filter(ig => ig.active === true)
    },
  });
};

export const setSubscriber = (data?: any) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_SUBSCRIBER,
    payload: data
  });
};


export const setModalMsg = (data: any) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_MODAL_MSG,
    payload: data,
  });
};
export const setModalCancelBtn = (data: any) => dispatch => {
  dispatch({
    type: ACTION_TYPES.SET_MODAL_CANCEL_BTN,
    payload: data,
  });
};
export const setSideBarUrls = (data: any) => async dispatch => {
  await dispatch({
    type: ACTION_TYPES.SET_SIDEBARE_URLS,
    payload: data,
  });
};

export const getSubscriptionFromSession = (data: any) => dispatch => {
  dispatch({
    type: ACTION_TYPES.GET_SUBSCRIPTION_FROM_SESSION,
    payload: data,
  });
};

export const init = () => dispatch => {
  dispatch({
    type: ACTION_TYPES.INIT,
  });
};

export const setLogoutDetails = (logoutData: any) => dispatch => {
  console.log('logoutData : ', logoutData);
  if (logoutData) {
    dispatch({
      type: ACTION_TYPES.LOGOUT,
      payload: logoutData,
    });
  }
};

export const blockUserWhenSubscriptionIsWrong = () => dispatch => {
  dispatch({
    type: SET_SHOW_ELIGIBILITY_MODAL,
    payload: true,
  });
  dispatch({
    type: ACTION_TYPES.SET_MODAL_MSG,
    payload: INVALID_SN_MSG_PRISMIC_ATTRIBUTE,
  });
  dispatch({
    type: ACTION_TYPES.SET_MODAL_CANCEL_BTN,
    payload: INVALID_SN_CANCEL_BTN_PRISMIC_ATTRIBUTE,
  });
}

const apiUrl = '/api/kubrick/';

export const findSubscriptionByNumber = (data) => async dispatch => {
  const requestUrl = apiUrl + 'findSubscription/' + data;

  dispatch(startLoading());
  try {
    const response = await axios.get(requestUrl, data);
    if (response && (response.status === 200 || response.status === 201) && response.data?.subscriptionNumber) {
      // sessionStorage.setItem('subscription', response.data?.subscriptionNumber);
      dispatch(setSubscription(response.data));
      dispatch(setStepEngineSubscription(response.data));
    }

    dispatch(stopLoading());
    return response;
  } catch (error) {
    console.log("error kubrick", error);
    dispatch(stopLoading());
    dispatch(setSubscription()); // without param to reset subscription
    dispatch(blockUserWhenSubscriptionIsWrong());
    return null;
  }
};

export const updateClient = async (data, dispatch) => {
  const requestUrl = apiUrl + 'updateSubscriber';
  try {
    const response = await axios.post<any>(requestUrl, data);
    if ((response.status === 200 || response.status === 201) && response.data) {
      dispatch(setSubscriber(response.data));
      dispatch(setStepEngineSubscriber(response.data));
      return response;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const getLogout = () => async dispatch => {
  const requestUrl = apiUrl + 'logout';
  dispatch(startLoading());
  try {
    const response = await axios.post<any>(requestUrl);
    if ((response?.status === 200 || response?.status === 201) && response?.data) {
      if (response.data) {
        dispatch(setLogoutDetails(response.data));
      }
      dispatch(stopLoading());
      return response;
    } else {
      dispatch(stopLoading());
      return false;
    }
  } catch (error) {
    dispatch(stopLoading());
    return false;
  }
};

export const getSession = () => async dispatch => {
  if (sessionStorage.getItem('subscription')) {
    await dispatch(findSubscriptionByNumber(sessionStorage.getItem('subscription')));
  }
};

export const logOut = () => async dispatch => {
  dispatch(startLoading());
  // sessionStorage.removeItem('subscription');
  await dispatch(getLogout());
  dispatch(stopLoading());
};

export const additionalCheckSSO: () => void = () => async (dispatch, getState) => {
  const requestUrl = apiUrl + 'additionalCheckSSO';
  await axios
    .get(requestUrl)
    .then(response => {
      return dispatch({
        type: ACTION_TYPES.ADDITIONAL_CHECK_SSO,
        payload: response.data,
      });
    })
    .catch(err => console.log("error additionalCheckSSO", err));
};

export const blockUserWhenAdditionalFieldsSsoMissed = () => dispatch => {
  dispatch({
    type: SET_SHOW_ELIGIBILITY_MODAL,
    payload: true,
  });
  dispatch({
    type: ACTION_TYPES.SET_MODAL_MSG,
    payload: REQUIRED_TOKEN_MSG_PRISMIC_ATTRIBUTE,
  });
  dispatch({
    type: ACTION_TYPES.SET_MODAL_CANCEL_BTN,
    payload: REQUIRED_TOKEN_CANCEL_BTN_PRISMIC_ATTRIBUTE,
  });
}